module.exports = "/static/assets/88fc2b4cf2491304618a71d2c94acc68.png";